export default __webpack_public_path__ + "static/media/Concerto di Maurizio Sebastianelli.a40d7429.jpg";